import { ROUTES, ROUTE_PARAMS, FUTRLI_MARKETING_SITE_URL } from '@futrli/shared-services';

/** MAIN */
export const _REJECTED = '_REJECTED';
export const RESET_ERROR_SUFFIX = '@@RESET';

/** FORMS */
export const FORGOT_PASSWORD_SUBMIT_FORM_ID = 'forgot-password-submit';
export const FORGOT_PASSWORD_FORM_ID = 'forgot-password';
export const REGISTER_FORM_ID = 'register';
export const INVITE_FORM_ID = 'invite';
export const LOGIN_FORM_ID = 'login';
export const VERIFIED_FORM_ID = 'verified';

/** FORM FIELDS */
export enum FORM_FIELDS {
  name = 'name',
  username = 'username',
  password = 'password',
  confirmPassword = 'confirmPassword',
  businessPhoneNumber = 'businessPhoneNumber',
  businessType = 'businessType'
}

/** AUTH ROUTES */
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const FORGOT_PASSWORD_SENT_ROUTE = '/forgot-password-sent';
export const LOGIN_ROUTE = '/login';
export const LOGOUT_ROUTE = '/logout';
export const MFA_ROUTE = '/verification';
export const MFA_SELECTION_ROUTE = '/mfa-options';
export const REGISTER_ROUTE = '/register';
export const REGISTER_BY_PRODUCT_ROUTE = `/register/:${ROUTE_PARAMS.PRODUCT_SLUG}`;
export const REGISTERED_ROUTE = '/registered';
export const REGISTERED_BY_PRODUCT_ROUTE = `/registered/:${ROUTE_PARAMS.PRODUCT_SLUG}`;
export const RESET_PASSWORD_CODE_USER_ROUTE = `/reset-password/:${ROUTE_PARAMS.CODE}/:${ROUTE_PARAMS.USER}`;
export const VERIFY_ROUTE = '/verify';
export const VERIFIED_ROUTE = '/verified';
export const VERIFIED_BY_PRODUCT_ROUTE = `/verified/:${ROUTE_PARAMS.PRODUCT_SLUG}`;
export const VERIFY_CODE_USER_ROUTE = `/verify/:${ROUTE_PARAMS.CODE}/:${ROUTE_PARAMS.USER}`;
export const VERIFY_CODE_USER_BY_PRODUCT_ROUTE = `/verify/:${ROUTE_PARAMS.PRODUCT_SLUG}/:${ROUTE_PARAMS.CODE}/:${ROUTE_PARAMS.USER}`;
export const INVITE_USER_ROUTE = `/invite/:${ROUTE_PARAMS.USER}`;
export const FEDERATED_SIGN_IN_REDIRECT = ROUTES.FEDERATED_SIGN_IN_REDIRECT;
export const FEDERATED_SIGN_IN_TRIGGER = ROUTES.FEDERATED_SIGN_IN_TRIGGER;
export const SAGE_ID_SIGN_IN_TRIGGER = ROUTES.SAGE_ID_SIGN_IN_TRIGGER;
export const SAGE_50_TRIGGER = ROUTES.SAGE_50_TRIGGER;
export const SFA_TRIGGER = ROUTES.SFA_TRIGGER;
export const SSO_EMBED_TRIGGER = ROUTES.SSO_EMBED_TRIGGER;

export const JOIN_US_URL = `${FUTRLI_MARKETING_SITE_URL}which-futrli-product`;

export const DESKTOP_LAYOUT_LIMIT = 1024;
